import { Calculator, Clock, Shield, Euro, Brain, Globe, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

export function WhyUsSection() {
  const { t } = useLanguage();

  const features = [
    {
      icon: Calculator,
      titleKey: "why_us.calculator.title",
      descriptionKey: "why_us.calculator.description",
      highlight: true,
    },
    {
      icon: Brain,
      titleKey: "why_us.ai.title",
      descriptionKey: "why_us.ai.description",
    },
    {
      icon: Clock,
      titleKey: "why_us.fast.title",
      descriptionKey: "why_us.fast.description",
    },
    {
      icon: Shield,
      titleKey: "why_us.security.title",
      descriptionKey: "why_us.security.description",
    },
    {
      icon: Euro,
      titleKey: "why_us.price.title",
      descriptionKey: "why_us.price.description",
    },
    {
      icon: Globe,
      titleKey: "why_us.delivery.title",
      descriptionKey: "why_us.delivery.description",
    },
  ];

  return (
    <section className="py-24 bg-background" aria-labelledby="why-us-heading">
      <div className="container mx-auto px-4">
        {/* Header */}
        <header className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-secondary font-semibold text-sm uppercase tracking-wider mb-4">
            {t("why_us.badge")}
          </span>
          <h2 id="why-us-heading" className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">
            {t("why_us.title")}
          </h2>
          <p className="text-lg text-muted-foreground">
            {t("why_us.subtitle")}
          </p>
        </header>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const cardContent = (
              <>
                {feature.highlight && (
                  <div className="absolute -top-3 -right-3 bg-warning text-warning-foreground text-xs font-bold px-3 py-1 rounded-full">
                    {t("why_us.unique_badge")}
                  </div>
                )}

                {/* Icon */}
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-6 ${
                  feature.highlight
                    ? "bg-primary-foreground/20"
                    : "bg-secondary/10"
                }`}>
                  <feature.icon className={`w-7 h-7 ${
                    feature.highlight ? "text-primary-foreground" : "text-secondary"
                  }`} />
                </div>

                {/* Content */}
                <h3 className={`font-display font-bold text-xl mb-3 ${
                  feature.highlight ? "text-primary-foreground" : "text-foreground"
                }`}>
                  {t(feature.titleKey)}
                </h3>
                <p className={`leading-relaxed ${
                  feature.highlight ? "text-primary-foreground/90" : "text-muted-foreground"
                }`}>
                  {t(feature.descriptionKey)}
                </p>
                
                {feature.highlight && (
                  <div className="flex items-center gap-2 mt-4 text-primary-foreground font-semibold">
                    <span>Vyskúšať kalkulačku</span>
                    <ArrowRight className="w-5 h-5" />
                  </div>
                )}
              </>
            );

            const cardClassName = `relative rounded-3xl p-8 transition-all duration-300 block ${
              feature.highlight
                ? "bg-gradient-to-br from-secondary to-primary text-primary-foreground shadow-2xl shadow-secondary/20 cursor-pointer hover:scale-[1.02]"
                : "bg-card border border-border hover:shadow-xl hover:border-secondary/30"
            }`;

            if (feature.highlight) {
              return (
                <Link key={index} to="/kalkulator" className={cardClassName}>
                  {cardContent}
                </Link>
              );
            }

            return (
              <div key={index} className={cardClassName}>
                {cardContent}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
